import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Fade from 'react-reveal/Fade';
import '../custom-build/steps.scss';

import buttonarrow from '../../assets/images/button-arrow.svg';
import person from '../../assets/images/person.svg';
import invoicingimg from '../../assets/images/invoicing.svg';

class InvoicingView extends Component {
    render() {
        return (
          <div className="home-content steps-content">
              <div className="homeleftcontent steps-left">
                <Fade right>
                    <h4>CustomBuilt automatically generates an invoice for your customer as soon as the order is shipped.</h4>
                </Fade>
                <Fade right><p className="steps-text">Batch or line-item invoicing can be done for multiple shipping locations or partial order quantities.</p></Fade>
                    <Fade right>
                        <div className="button-section">
                            <Link to="/shipping" className="theme-btn backarrow-btn"><img alt="" src={buttonarrow} /></Link>
                            <Link to="" className="theme-btn">schedule a demo <img alt="" src={buttonarrow} /></Link>
                        </div>
                </Fade>
                <div className="bottom-person">
                    <Fade right>
                        <img alt="Customer Portal" src={person} />
                        <div className="person-right">
                            <h3>Make payment</h3>
                            <small>Customer Portal</small>
                        </div>
                    </Fade>
                </div>
              </div>
              <div className="homerightcontent">
                  <Fade right>
                      <img alt="Custom Built" className="invoicing-img" src={invoicingimg} />
                  </Fade>
              </div>
          </div>
        )
    }
}

export default InvoicingView
